import React from 'react';
import { useHistory } from 'react-router-dom';

import { COOKIES } from '../../_shared/constants/cookies';
import AutoWinSettingModal from '../../components/AutoWinSettingModal';
import navigateBack from '../../_shared/helpers/navigateBack';
import AutoWinSettingOmp from '../../components/AutoWinSettingOmp';

const BidSettings = ({ isOmp = false }) => {
  const history = useHistory();

  if (!isOmp) {
    return (
      <AutoWinSettingModal
        testId="autoWinSettingPage"
        isModalOpen
        closeHandler={() =>
          navigateBack(COOKIES.GO_BACK_FROM_TR5_SETTING, history)
        }
      />
    );
  }

  return <AutoWinSettingOmp />;
};

export default BidSettings;
